import React from 'react';
import { Helmet } from 'react-helmet-async';
import KshitiHeadshot from '../images/Kshiti Headshot.svg';
import Linkedin from '../images/Linkedin-logo.svg';
import Medium from '../images/Medium-logo.svg';
import Award from '../images/Kshiti-award.svg';
import AwardFinalist from '../images/Award Finalist.png';

const About = () => {
  return (
    <div>
      <Helmet>
        <title>Kshiti :: About</title>
      </Helmet>
    <section className="home-hero">
        <div className="row">
          <div className="col home-hero-content">
            <h1>
            A LITTLE <br/>
              <span className="highlight-color">ABOUT MYSELF.</span>
            </h1>
            <h2>
            <span className="highlight-color">Living, Learning, & Leveling</span> up one day at a time.
            </h2>
            <p>
            Learn a little bit more about me, how I got into design and development, and how I built my career in both fields. <br/><br/>
            Fun fact - I have being designing and developing since I was 18 years old.
            </p>
          </div>
          <div className="col">
            <div className="hero-image">
              <div className='about-hero-social'>
                <a href='https://www.linkedin.com/in/kshiti-ghelani/' target='_blank' className='footer-social-logo'><img src={Linkedin} alt="Linkedin logo"/></a>
                <a href='https://medium.com/@kshitighelani' target='_blank' className='footer-social-logo'><img src={Medium} alt="Medium logo"/></a>
              </div>
              <img src={KshitiHeadshot} alt="Kshiti Headshot" className="hero-image-1" />
            </div>
          </div>
        </div>
    </section>
    <section>
      <div className='container'>
        <h6 className='primary-highlight'>
          <span>01</span><span className="container-heading">About</span>
        </h6>
        <div className='container-content'>
          <p>I'm not your usual designer focused on pixel-perfect details — my design approach is more comprehensive. You’ll find me working in code, refining styles, and thoughtfully planning layouts to create seamless, user-friendly experiences that are both functional and aesthetically pleasing. Whether I’m building dynamic web applications or crafting intuitive user interfaces, performance and scalability are always at the forefront of my work.</p>
          <p>Over the past few years, I’ve worked with agencies, universities, and national organizations to design and build digital experiences that are both functional and visually engaging. My work spans everything from creating responsive websites and reusable UI components to optimizing campaigns for performance and accessibility.</p>
          <p className='primary-highlight'>I have:</p>
            <ul>
              <li>Front-end expertise in <b>HTML, CSS, JavaScript, React</b>, with hands-on experience in <b>Shopify and Liquid templates</b>.</li>
              <li>Worked extensively with <b>custom APIs</b> to pull and manage data within Shopify, enabling more dynamic and scalable storefronts.</li>
              <li>Strong background in UI/UX design, from wireframes and prototypes in <b>Figma/Photoshop</b> to polished, user-friendly interfaces.</li>
              <li>Proven ability to deliver <b>cross-browser compatible, WCAG-compliant websites</b>, with a focus on performance, scalability, and accessibility.</li>
              <li>Experience working across the stack with <b>PHP, MySQL, .NET</b>, and cloud tools like <b>Google Cloud Console</b>.</li>
              <li>Advanced skills in <b>GitHub for version control</b> and CI/CD workflows, and <b>Firebase for hosting</b>, authentication, and deployment.</li>
              <li><b>Strong communication skills</b> - equally comfortable collaborating with teams, presenting ideas to stakeholders, or leading client discussions.</li>
            </ul>
        </div>
      </div>
    </section>
    <section className='about-kshiti-limelight'>
        <div className='row container'>
            <div className='col-70'>
                  <h6 className='primary-highlight'>
                      <span>02</span><span className="container-heading">Limelight</span>
                  </h6>
                  <div className='container-content'>
                      <p>It's my pleasure to be a finalist for Digital Nova Scotia Tech Forward Awards - category "One To Watch" in regards to recognizing organizations and individuals who are making a difference in Nova Scotia’s technology sector. </p>
                      <p className='primary-highlight'>I was nominated for - One To Watch Award by Digial Nova Scotia and was a finalist for the same category.</p>
                      <p>Honours an individual (not in a senior or executive role) who identifies as a member of an underrepresented community in tech*, and is an emerging new talent in the industry, demonstrating exceptional skills and ambition, whose endeavors are helping them stand out from the crowd.</p>
                  </div>
            </div>
            <div className='col-30'>
                <div className="hero-image">
                <img src={Award} alt="Kshiti Award" className="hero-image-1" />
                <img src={AwardFinalist} alt="Tech Forward Award Finalist" className="hero-image-2" />
                </div>
            </div>
        </div>
    </section>
    <section className='about-education primary-background'>
        <div className='container'>
            <h6>
                <span>03</span><span className="container-heading">Educational Background</span>
            </h6>
          <div className='about-content container-content'>
              <p>I bring a lot of energy and curiosity into everything I do. I enjoy learning quickly, taking on new challenges, and balancing different projects at once. Over time, I’ve built skills across different areas, and I’m always excited to keep growing and exploring new directions in my work and creativity.</p>
              <p><b>I have degrees in:</b></p>
              <ul>
                  <li>Master of Applied Computer Science from St. Francis Xavier University, Canada</li>
                  <li>Master of Computer Applications from Sardar Patel University, India</li>
                  <li>Bachelor of Computer Applications from Saurashtra University, India</li>
              </ul>
          </div>
        </div>
    </section>
    </div>
  );
};

export default About;
